module.exports = __webpack_public_path__ + "img/background.078c3676.png";